// Aeros application roles

const ROLES = Object.freeze({
    continuumAdministrator: 'Continuum administrator',
    dataProductOwner: 'Data product owner',
    dataConsumer: 'Data consumer',
    aerosUser: 'aerOS user'
})

export default ROLES